module.exports = __webpack_public_path__ + "img/header.87f59467.jpg";